import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@material-ui/core';
import { makeStyles, Text } from '@knockrentals/knock-shared-web';
import ConfirmationDialog from '../../../../Features/common/ConfirmationDialog';
import { UPDATE_CONFIRMATION } from './constants';

const useStyles = makeStyles({
  activateButton: {
    backgroundColor: '#D21A32',
  },
});

const ProductSettingsConfirmationDialog = ({
  confirmationMode,
  handleCancel,
  handleConfirmation,
  openDownloadModal,
}) => {
  const classes = useStyles();

  const message = (
    <React.Fragment>
      <Text paragraph variant="body1">
        {UPDATE_CONFIRMATION.MESSAGE}
      </Text>
      <Text component="p" variant="caption">
        {UPDATE_CONFIRMATION.DOWNLOAD_MESSAGE_PREFIX}
        <Link
          component="button"
          onClick={openDownloadModal}
          underline="always"
          variant="caption"
        >
          {UPDATE_CONFIRMATION.CSV_DOWNLOAD_LABEL}
        </Link>
        {UPDATE_CONFIRMATION.DOWNLOAD_MESSAGE_SUFFIX}
      </Text>
    </React.Fragment>
  );

  return (
    <ConfirmationDialog
      handleConfirmation={handleConfirmation}
      isOpen={!!confirmationMode}
      message={message}
      primaryButtonClass={classes.activateButton}
      primaryButtonText={UPDATE_CONFIRMATION.CONFIRM_BUTTON}
      secondaryButtonAction={handleCancel}
      title={UPDATE_CONFIRMATION.TITLES[confirmationMode]}
    />
  );
};

ProductSettingsConfirmationDialog.propTypes = {
  confirmationMode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirmation: PropTypes.func.isRequired,
  openDownloadModal: PropTypes.func.isRequired,
};

export default ProductSettingsConfirmationDialog;
